import { find, has, some } from 'lodash';

/**
 * Param keys that identify markets with selectable param variants
 * (e.g. milestone lines, period lines). Expand this list to support new types.
 */
export const PARAM_VARIANT_KEYS = ['MILESTONE', 'MILESTONE_YARDS', 'PERIOD'];

export const hasParamVariant = (params) => some(PARAM_VARIANT_KEYS, (key) => has(params, key));

export const getParamVariantValue = (params) => {
  const key = find(PARAM_VARIANT_KEYS, (paramKey) => has(params, paramKey));
  return key ? params[key] : undefined;
};
